/**
 * SecondAura : filtre « État » de la collection et de la recherche.
 *
 * L'état d'une paire arrive de Shopify sous plusieurs formes (ses traductions, paire par paire). Le thème n'affiche
 * qu'une case par état : elle porte la première valeur, et les autres valeurs du même état sont des cases cachées
 * dans le même `<li data-sa-etat>` (voir snippets/list-filter.liquid). Ici, on coche ou décoche les cases cachées
 * avec la case visible.
 *
 * À l'écoute sur `window` en phase de capture : le thème lit le formulaire sur `change` depuis `document`
 * (assets/component.js), il faut donc passer avant lui.
 */
window.addEventListener(
  'change',
  (event) => {
    const caseVisible = event.target;
    if (!(caseVisible instanceof HTMLInputElement) || caseVisible.type !== 'checkbox') return;

    const groupe = caseVisible.closest('[data-sa-etat]');
    if (!groupe) return;

    for (const caseLiee of groupe.querySelectorAll('input.sa-etat-liee')) {
      if (caseLiee instanceof HTMLInputElement) caseLiee.checked = caseVisible.checked;
    }
  },
  { capture: true }
);
